export const TRANSACTION_STATUS = {
    IN_PROGRESS : 'IN_PROGRESS',
    SUCCESS : 'SUCCESS',
    FAILED : 'FAILED',
    CANCELLED: 'CANCELLED',
    REFUNDED: 'REFUNDED'
}